<script setup lang="ts">
import { Calculator, Mail } from "@lucide/vue";
</script>

<template>
  <footer class="bg-muted/40 border-t border-border mt-auto">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <!-- Brand -->
        <div>
          <router-link to="/" class="flex items-center gap-2 text-lg font-bold text-primary mb-3">
            <div class="w-7 h-7 bg-primary rounded-lg flex items-center justify-center">
              <Calculator class="h-4 w-4 text-primary-foreground" />
            </div>
            CPABuddy
          </router-link>
          <p class="text-sm text-muted-foreground leading-relaxed">
            专为审计师和CPA考生设计的专业数据处理与备考平台。提供在线刷题、学习计划、离线Excel工具和辅助。
          </p>
        </div>

        <!-- CPA学习 -->
        <div>
          <h4 class="text-sm font-semibold text-foreground mb-3">CPA学习</h4>
          <ul class="space-y-2">
            <li><router-link to="/cpa/bank" class="text-sm text-muted-foreground hover:text-primary transition">刷题中心</router-link></li>
            <li><router-link to="/cpa/knowledge" class="text-sm text-muted-foreground hover:text-primary transition">知识精讲</router-link></li>
            <li><router-link to="/cpa/study-plan" class="text-sm text-muted-foreground hover:text-primary transition">学习计划</router-link></li>
            <li><router-link to="/cpa/progress" class="text-sm text-muted-foreground hover:text-primary transition">学习进度</router-link></li>
          </ul>
        </div>

        <!-- 工具与下载 -->
        <div>
          <h4 class="text-sm font-semibold text-foreground mb-3">工具与下载</h4>
          <ul class="space-y-2">
            <li><router-link to="/download" class="text-sm text-muted-foreground hover:text-primary transition">离线下载</router-link></li>
            <li><router-link to="/feedback" class="text-sm text-muted-foreground hover:text-primary transition">用户反馈</router-link></li>
          </ul>
        </div>

        <!-- 联系 -->
        <div>
          <h4 class="text-sm font-semibold text-foreground mb-3">关于</h4>
          <ul class="space-y-2">
            <li class="flex items-center gap-2 text-sm text-muted-foreground">
              <Mail class="h-4 w-4" />
              <span>support@cpabuddy.com</span>
            </li>
            <li class="flex items-center gap-2 text-sm text-muted-foreground">
              <svg class="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/>
              </svg>
              <span>GitHub</span>
            </li>
          </ul>
          <p class="text-xs text-muted-foreground/80 mt-4">
            本网站所载CPA考试信息仅供参考，具体以中国注册会计师协会（CICPA）官网为准。
          </p>
        </div>
      </div>

      <div class="border-t border-border mt-8 pt-6 text-center">
        <p class="text-xs text-muted-foreground/80">
          &copy; {{ new Date().getFullYear() }} CPABuddy. All rights reserved. 中国注册会计师协会考试信息仅供参考。
        </p>
        <p class="text-xs text-muted-foreground/80 mt-2">
          <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
            rel="noopener noreferrer"
            class="hover:text-primary transition"
          >
            ICP备案/许可证号：粤ICP备2026086544号-1
          </a>
        </p>
        <p class="text-xs text-muted-foreground/80 mt-2">
          <a
            href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011302005651"
            target="_blank"
            rel="noopener noreferrer"
            class="hover:text-primary transition"
          >
            粤公网安备44011302005651号
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>
